import React from 'react'
import { useLocation } from 'react-router-dom'
import { TbArrowsLeftRight } from "react-icons/tb";
import moment from "moment";
import './BookingAddressDetail.css'
import { BiChevronsRight } from "react-icons/bi";
const BookingAddressDetail = () => {
    const location = useLocation();

    console.log("BookingAddrelocation",location)
  return (
    <>
      {location?.state?.tab === 0 && location?.state?.makeDisable && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div>{location?.state?.departureLocation}</div>
            <BiChevronsRight className="iconsBooking" />
            <div className="durationTxtStprBkingArri">
              {location?.state?.arrivalLocation}
            </div>
            <div className="durationTxtStprBking">
              Duration: about 1 hour – Distance:{" "}
              {(location?.state?.totalDistance * 0.621371192).toFixed(2)} MI
            </div>
            <div className="durationTxtStprBking">
              Date:{moment(location?.state?.departureDate).format("DD-MM-YYYY")}
              , Time: {location?.state?.departureTime}
            </div>
          </div>
        </div>
      )}

      {location?.state?.tab === 0 && !location?.state?.makeDisable && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div>{location?.state?.departureLocation}</div>
            <TbArrowsLeftRight className="iconsBooking" />
            <div className="durationTxtStprBkingArri">
              {location?.state?.arrivalLocation}
            </div>
            <div className="durationTxtStprBking">
              Duration: about 1 hour – Distance:{" "}
              {location?.state?.totalDistance}Km
            </div>
            <div className="durationTxtStprBking">
              Date:{moment(location?.state?.departureDate).format("DD-MM-YYYY")}
              , Time: {location?.state?.departureTime}
            </div>
          </div>
        </div>
      )}

      {location?.state?.tab === 1 && (
        <div className="mainInfoBooking">
          <div className="mainInfoBookingInner">
            <div className="durationTxtStprBkingArri">
              {location?.state?.departureLocation}
            </div>
            <div className="durationTxtStprBking">
              {" "}
              Time: {location?.state?.hourlyDuration}Hour
            </div>
            <div className="durationTxtStprBking">
              Date:
              {moment(location?.state?.startDateHourly).format("DD-MM-YYYY")}
            </div>
            <div className='durationTxtStprBking'>
               Depature Time: {location?.state?.hourlyTime}
            </div>
          </div>
        </div>
      )}


<div className='topVias'>
 {(location?.state?.via1||location?.state?.via2||location?.state?.via3) &&<div className='topViasInner'> 
{location?.state?.via1&&  <div>Via1: {location?.state?.via1}</div>}
 {location?.state?.via2&& <div>Via2: {location?.state?.via2}</div>}
  {location?.state?.via3&&<div>Via3: {location?.state?.via3}</div>}

  </div>}

</div>

    </>
  )
}

export default BookingAddressDetail